import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import translationsData from './locales/translations.json';

// Detect browser language or geo-location
const getBrowserLanguage = () => {
  // First check localStorage (user preference)
  const saved = localStorage.getItem('language');
  if (saved) return saved;
  
  // Then check browser language
  const lang = navigator.language || navigator.userLanguage;
  const code = lang.split('-')[0]; // Get 'it' from 'it-IT'
  const supported = ['en', 'it', 'es', 'fr', 'de'];
  
  // Map common browser languages
  if (supported.includes(code)) return code;
  
  // Fallback to English
  return 'en';
};

// Transform translations to i18next format
const resources = {};
Object.keys(translationsData).forEach(lang => {
  resources[lang] = {
    translation: translationsData[lang]
  };
});

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: localStorage.getItem('language') || getBrowserLanguage(),
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false
    }
  });

// Listen for language changes and persist to localStorage
i18n.on('languageChanged', (lng) => {
  localStorage.setItem('language', lng);
  document.documentElement.setAttribute('lang', lng);
});

// Set initial language on DOM
document.documentElement.setAttribute('lang', i18n.language);

export default i18n;